//export const API = "http://localhost:8001/api";

export const API = "https://api.bayadirect.com/";
// process.env.REACT_APP_API_URL;
// 'http://localhost:8000/api'
